'use client';

import { useEffect, useState } from "react";
import { loadEntranceFeeFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import { SlideOutEntranceFee } from "@/app/lib/generated/graphql-types";
import FlyoutWrapper from "../../FlyoutWrapper";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Box } from "@mui/material";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { Stack } from "@mui/system";
import LinkButton from "@/app/features/shared/__to_be_integrated/LinkButton";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";

export default function EntranceFeeFlyoutInfo() {
    const [content, setContent] = useState<SlideOutEntranceFee>();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            const  { data, error } = await loadEntranceFeeFlyoutContent();
            if (error || !data) {
                console.error('Error loading entrance fee flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            backgroundImage={content.image}
            hideBackgroundOnMobile={false}
            slots={{
                paper: {
                    sx: {
                        width: { md: '33vw' },
                    }
                }
            }}
        >
            <Stack spacing={4} sx={{ py: 2 }}>
                <FlyoutHeaderTypography>{content.title}</FlyoutHeaderTypography>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                    <Markdown value={content.description}  />
                </Box>
                <Stack direction="row">
                    {content.links.filter(link => link !== null).map((link, index) => (
                        <LinkButton
                            key={index}
                            link={link}
                            fullWidth
                        />
                    ))}
                </Stack>
            </Stack>
        </FlyoutWrapper>
    )
}
